module.exports = __webpack_public_path__ + "img/CPS200_1-1.340c901d.jpg";